import React from 'react'
import Modal from '../../../components/Modal'
import { formatMoney } from '../utils/paymentHelpers'

const formatDateShort = (dateStr) => {
  if (!dateStr) return ''
  const cleanStr = String(dateStr).split('T')[0]
  const parts = cleanStr.split('-')
  if (parts.length === 3) {
    const d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10))
    return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })
  }
  return new Date(dateStr).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })
}

const formatPeriodRange = (start, end) => {
  if (!start && !end) return ''
  if (!start) return `по ${formatDateShort(end)}`
  if (!end) return `с ${formatDateShort(start)}`
  return `${formatDateShort(start)} — ${formatDateShort(end)}`
}

export function PayoutsDetailModal({
  showPayoutsDetailModal,
  setShowPayoutsDetailModal,
  filterPeriodStart,
  filterPeriodEnd,
  loadingPayoutsDetail,
  payoutsDetailList = [],
  employees = [],
  isAdmin,
  handleDeletePayout
}) {
  const totalAmount = (payoutsDetailList || []).reduce((sum, p) => sum + (Number(p.amount) || 0), 0)
  const modalTitle = totalAmount > 0
    ? `Выплаты, учтённые в сумме ${formatMoney(totalAmount)}`
    : 'Выплаты ЗП'

  return (
    <Modal
      isOpen={showPayoutsDetailModal}
      onClose={() => setShowPayoutsDetailModal(false)}
      title={modalTitle}
      isBottomSheet={true}
      customWidth="600px"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', padding: '4px 0 16px' }}>
        <div style={{ fontSize: '12px', color: 'var(--text-secondary)', background: 'var(--surface-hover)', padding: '10px 14px', borderRadius: '8px', border: '1px solid var(--border-color)', lineHeight: '1.4' }}>
          Некоторые выплаты включают зарплату за дни за пределами выбранного периода.
        </div>

        {loadingPayoutsDetail ? (
          <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--text-secondary)' }}>
            <div className="spinner" style={{ margin: '0 auto 12px auto' }}></div>
            Загрузка истории выплат...
          </div>
        ) : payoutsDetailList.length === 0 ? (
          <div style={{ padding: '40px 20px', textAlign: 'center', color: 'var(--text-tertiary)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <span>За выбранный период подходящих выплат нет.</span>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '60vh', overflowY: 'auto', paddingRight: '4px' }}>
            {payoutsDetailList.map((p) => {
              const empName = p.employee_name || employees.find(e => e.id === p.employee_id)?.name || 'Сотрудник'
              const periodRange = formatPeriodRange(p.period_start, p.period_end)
              const periodLabel = periodRange ? `Зарплата за ${periodRange}` : 'Зарплата'
              const payDate = p.created_at ? formatDateShort(p.created_at) : null

              return (
                <div
                  key={p.id}
                  style={{
                    background: 'var(--surface)',
                    border: '1px solid var(--surface-border)',
                    borderRadius: '12px',
                    padding: '12px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '6px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div style={{ fontWeight: 700, fontSize: '15px', color: 'var(--text-primary)', wordBreak: 'break-word' }}>
                        {empName}
                      </div>
                      <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '2px' }}>
                        {periodLabel}
                      </div>
                      {payDate && (
                        <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '2px' }}>
                          Выплачено {payDate}
                        </div>
                      )}
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                      <span style={{ fontWeight: 700, fontSize: '15px', color: 'var(--success)', whiteSpace: 'nowrap' }}>
                        +{formatMoney(p.amount)}
                      </span>
                      {isAdmin && (
                        <button
                          className="btn btn-ghost"
                          style={{ padding: '6px', color: 'var(--danger)', borderRadius: '6px', minWidth: 'auto', height: 'auto' }}
                          onClick={() => handleDeletePayout(p.id, p.amount, empName)}
                          title="Отменить выплату"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                        </button>
                      )}
                    </div>
                  </div>

                  {p.comment && (
                    <div style={{ fontSize: '12px', color: 'var(--text-secondary)', background: 'var(--surface-hover)', padding: '6px 10px', borderRadius: '6px', fontStyle: 'italic', marginTop: '2px', wordBreak: 'break-word' }}>
                      {p.comment}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}

        <div style={{ marginTop: '12px' }}>
          <button className="btn btn-ghost" style={{ width: '100%' }} onClick={() => setShowPayoutsDetailModal(false)}>
            Закрыть
          </button>
        </div>
      </div>
    </Modal>
  )
}
